/* @flow */
import {
    getDiscountCodeRestrictions,
    getPaymentFrequencyKey,
    getPaymentFrequencyOptionFromKey
} from '../utility/comparator';

export default ngModule => {
    ngModule.factory('OperatorService', function (AonConfig, AonApplicationService) {

        class OperatorService {

            constructor() {
                this.filters = {
                    offset: 0,
                    referral_fund: false,
                    include_future_pricing: true,
                    display_order: "price_lowhi",
                    payment_frequency: "monthly",
                    // If a discount code is selected that limits e.g. the payment frequency, we need to
                    // indicate that the frequency filter is disabled
                    payment_frequency_disabled: false,
                    hospital_classifications: AonConfig.formChoices.hospital_classification_filter_options
                        .map(classification => {
                            return {
                                code: classification[0],
                                name: classification[1],
                                selected: true,
                            };
                        }),
                    show_current_policy: AonConfig.corporate.display_current_policy_on_comparison_page,
                    show_comparison_policy: AonConfig.corporate.is_service_comparison_tool,
                    show_products_from_current_fund: true,
                    funds: AonConfig.formChoices.known_funds.map(f => {
                        return {
                            code: f[0],
                            name: f[1],
                            restricted: f[2],
                            selected: true,
                        };
                    }),
                    non_panel_funds: AonConfig.formChoices.non_panel_funds.map(f => ({
                        code: f[0],
                        name: f[1],
                        // We default the non-panel funds to NOT selected
                        selected: false,
                    })),
                };

                this.updateApplicantDependantFilters();

                if (AonConfig.formChoices.discount_code_choices.length) {
                    this.filters.discount_code_choices = AonConfig.formChoices.discount_code_choices;
                }

                this.controls = {
                    allFundsSelected: true,
                    allTiersSelected: true,
                    allFundsSelectedNonPanel: false,
                };
            }

            hasDefaultDiscount() {
                return !!AonConfig.formChoices.discount_code_default;
            }

            // Update the payment frequency filter to match the applicant's data (likely retrieved from zoho)
            // Defaults to 'monthly'
            updateApplicantDependantFilters() {
                AonApplicationService.getApplication().then(applicant => {
                    const paymentFrequency = _.get(applicant, 'payment.frequency', AonConfig.jsConstants.PaymentFrequencies.Monthly);
                    this.filters.payment_frequency = getPaymentFrequencyOptionFromKey(getPaymentFrequencyKey(paymentFrequency));
                    this.filters.discount_code = _.get(applicant, 'policy.discount_code', AonConfig.formChoices.discount_code_default);
                    this.updateDiscountDependantFilters();
                });
            }

            // If a discount can be selected and changed, we may need to force a particular payment frequency,
            // depending on the configuration of the discount. Perform that update here.
            updateDiscountDependantFilters() {
                AonApplicationService.getApplication().then(applicant => {
                    let disable_payment_frequency = false;
                    if (this.filters.discount_code) {
                        const discountRestrictions = getDiscountCodeRestrictions(this.filters.discount_code);
                        if (discountRestrictions && Number.isFinite(discountRestrictions.payment_frequency)) {
                            // Update the payment frequency on the applicant
                            _.set(applicant, 'payment.frequency', discountRestrictions.payment_frequency);
                            // Update the operator filter
                            this.filters.payment_frequency = getPaymentFrequencyOptionFromKey(
                              getPaymentFrequencyKey(discountRestrictions.payment_frequency)
                            );
                            // Disable select of other payment frequencies
                            disable_payment_frequency = true;
                        }
                    }
                    this.filters.payment_frequency_disabled = disable_payment_frequency;
                });
            }

            setSelectedTiers(tiers) {
                const allSelected = !tiers || !tiers.length;
                this.filters.hospital_classifications.forEach(tierFilter => {
                    tierFilter.selected = allSelected ? true : tiers.includes(tierFilter.code);
                });
                this.controls.allTiersSelected = this.filters.hospital_classifications.every(
                  tierFilter => tierFilter.selected
                );
            }

            paymentFrequencyChoices() {
                // Convert the list that we get from the backend [(numeric frequency code, label)] into
                // [(string frequency code, label)] that is expected in order to extract payment frequency
                // values from the api response.
                return AonConfig.formChoices.payment_frequency_filter_choices.map(([code, label]) => [
                  getPaymentFrequencyOptionFromKey(getPaymentFrequencyKey(code)),
                  label,
                ])
            }
        }

        return new OperatorService();
    });
};



// WEBPACK FOOTER //
// ./src/services/operator-service.js